import * as Icons from '@mui/icons-material';

export const getAllMaterialIcons = () => {
  const allIcons = [];

  for (const key in Icons) {
    if (Object.prototype.hasOwnProperty.call(Icons, key)) {
      const IconComponent = Icons[key];
      allIcons.push(IconComponent);
    }
  }

  return allIcons.filter((a, idx) => (idx + 1)%5 === 0);
};
